// extracted by mini-css-extract-plugin
export default {"emptyRules":"EmptyPlaceholder_emptyRules__Sm8CK","addNewRuleTitle":"EmptyPlaceholder_addNewRuleTitle__GLtkA"};